/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './change-pallet.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/flex-layout/flexbox/api/layout';
import * as i5 from '@angular/flex-layout/media-query/media-monitor';
import * as i6 from '@angular/flex-layout/flexbox/api/layout-gap';
import * as i7 from '@angular/flex-layout/flexbox/api/class';
import * as i8 from '@angular/forms';
import * as i9 from '@angular/flex-layout/flexbox/api/flex';
import * as i10 from '@angular/flex-layout/flexbox/api/layout-wrap';
import * as i11 from '@angular/common';
import * as i12 from '../../../../../../app/shared/pipes/translate.pipe';
import * as i13 from '@angular/router';
import * as i14 from '../../../../../../app/agatextscreens/pda/inventory/change-pallet/change-pallet.component';
import * as i15 from '@angular/flex-layout/flexbox/api/flex-align';
import * as i16 from '../../../../../../app/shared/services/pallet.service';
import * as i17 from '@angular/http';
import * as i18 from '../../../../../../app/app.constants';
import * as i19 from '../../../../../../app/shared/services/authentication.service';
import * as i20 from '@covalent/core/dialogs/services/dialog.service';
import * as i21 from '../../../../../../app/agatextscreens/inventory/inventory.service';
const styles_InvChangeLocationComponent:any[] = [i0.styles];
export const RenderType_InvChangeLocationComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_InvChangeLocationComponent,data:{}});
function View_InvChangeLocationComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i2.View_MdOption_0,i2.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[1,4]],0,i3.MdOption,[i1.ElementRef,[2,i3.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['',' -\n              ',
          '']))],(_ck,_v) => {
    const currVal_9:any = _v.context.$implicit.id;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit.code;
    const currVal_11:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_10,currVal_11);
  });
}
function View_InvChangeLocationComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),19,'div',[['class',
      'padded-container'],['fxLayout','row'],['fxLayout.lt-md','column'],['fxLayoutGap',
      '30px'],['fxLayoutGap.lt-md','14px']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i4.LayoutDirective,
      [i5.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,
          'layoutLtMd']},(null as any)),i1.ɵdid(1720320,(null as any),0,i6.LayoutGapDirective,
      [i5.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i4.LayoutDirective]],{gap:[0,
          'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
      0,i7.ClassDirective,[i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),
      i1.ɵted((null as any),['\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      13,'md-select',[['fxFlex','47%'],['name','branch'],['role','listbox']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[1,'tabindex',0],[1,'aria-label',
              0],[1,'aria-labelledby',0],[1,'aria-required',0],[1,'aria-disabled',
              0],[1,'aria-invalid',0],[1,'aria-owns',0],[2,'mat-select-disabled',(null as any)],
          [2,'mat-select',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
          'keydown'],[(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,10)._handleClosedKeydown($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,10)._onBlur()) !== false);
          ad = (pd_1 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_2:any = ((<any>(_co.branchFilter = $event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i2.View_MdSelect_0,i2.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),0,
      i8.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,(null as any)]],
      {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
      i8.NgControl,(null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
      [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(1294336,(null as any),1,i3.MdSelect,[i1.ElementRef,i1.Renderer2,i3.ViewportRuler,
          i1.ChangeDetectorRef,[2,i3.Dir],[2,i8.NgControl],[8,(null as any)]],{placeholder:[0,
          'placeholder']},(null as any)),i1.ɵqud(603979776,1,{options:1}),i1.ɵppd(2),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i5.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i4.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵand(16777216,
          (null as any),0,2,(null as any),View_InvChangeLocationComponent_2)),i1.ɵdid(802816,
          (null as any),0,i11.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),i1.ɵpid(131072,i11.AsyncPipe,[i1.ChangeDetectorRef]),
      (_l()(),i1.ɵted(0,['\n          '])),(_l()(),i1.ɵted((null as any),['\n        ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = 'row';
        const currVal_1:any = 'column';
        _ck(_v,1,0,currVal_0,currVal_1);
        const currVal_2:any = '30px';
        const currVal_3:any = '14px';
        _ck(_v,2,0,currVal_2,currVal_3);
        const currVal_4:any = 'padded-container';
        _ck(_v,3,0,currVal_4);
        const currVal_21:any = 'branch';
        const currVal_22:any = _co.branchFilter;
        _ck(_v,6,0,currVal_21,currVal_22);
        const currVal_23:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,10,0,_ck(_v,12,
            0,i1.ɵnov((<any>_v.parent),0),'branch',_co._authService.getLanguage())),
            '');
        _ck(_v,10,0,currVal_23);
        const currVal_24:any = '47%';
        _ck(_v,13,0,currVal_24);
        const currVal_25:any = i1.ɵunv(_v,16,0,i1.ɵnov(_v,17).transform(_co.allBranches$));
        _ck(_v,16,0,currVal_25);
      },(_ck,_v) => {
        const currVal_5:any = i1.ɵnov(_v,8).ngClassUntouched;
        const currVal_6:any = i1.ɵnov(_v,8).ngClassTouched;
        const currVal_7:any = i1.ɵnov(_v,8).ngClassPristine;
        const currVal_8:any = i1.ɵnov(_v,8).ngClassDirty;
        const currVal_9:any = i1.ɵnov(_v,8).ngClassValid;
        const currVal_10:any = i1.ɵnov(_v,8).ngClassInvalid;
        const currVal_11:any = i1.ɵnov(_v,8).ngClassPending;
        const currVal_12:any = i1.ɵnov(_v,10).tabIndex;
        const currVal_13:any = i1.ɵnov(_v,10)._ariaLabel;
        const currVal_14:any = i1.ɵnov(_v,10).ariaLabelledby;
        const currVal_15:any = i1.ɵnov(_v,10).required.toString();
        const currVal_16:any = i1.ɵnov(_v,10).disabled.toString();
        const currVal_17:any = (((i1.ɵnov(_v,10)._control == null)? (null as any): i1.ɵnov(_v,
            10)._control.invalid) || 'false');
        const currVal_18:any = i1.ɵnov(_v,10)._optionIds;
        const currVal_19:any = i1.ɵnov(_v,10).disabled;
        const currVal_20:any = true;
        _ck(_v,5,1,[currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,
            currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17,currVal_18,
            currVal_19,currVal_20]);
      });
}
function View_InvChangeLocationComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),36,'div',[['class',
      'padded-container'],['fxLayout','row'],['fxLayout.lt-md','column'],['fxLayoutGap',
      '30px'],['fxLayoutGap.lt-md','14px']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i4.LayoutDirective,
      [i5.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,
          'layoutLtMd']},(null as any)),i1.ɵdid(1720320,(null as any),0,i6.LayoutGapDirective,
      [i5.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i4.LayoutDirective]],{gap:[0,
          'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
      0,i7.ClassDirective,[i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),
      i1.ɵted((null as any),['          \n        \n          '])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),18,'md-input-container',[['fxFlex','47%']],[[1,'align',
          0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',(null as any)],
          [2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
          [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
              (null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,6)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
      (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,[2,i8.NgForm],
          [2,i8.FormGroupDirective]],(null as any),(null as any)),i1.ɵqud(335544320,
      2,{_mdInputChild:0}),i1.ɵqud(335544320,3,{_placeholderChild:0}),i1.ɵqud(603979776,
      4,{_errorChildren:1}),i1.ɵqud(603979776,5,{_hintChildren:1}),i1.ɵqud(603979776,
      6,{_prefixChildren:1}),i1.ɵqud(603979776,7,{_suffixChildren:1}),i1.ɵdid(737280,
      (null as any),0,i9.FlexDirective,[i5.MediaMonitor,i1.ElementRef,i1.Renderer2,
          [3,i4.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,'flex']},(null as any)),
      (_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,(null as any),1,7,'input',
          [['mdInput','']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],
              [2,'mat-input-element',(null as any)],[8,'id',0],[8,'placeholder',0],
              [8,'disabled',0],[8,'required',0],[1,'aria-describedby',0]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend'],[(null as any),
              'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,16)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,16).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,16)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,16)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,21)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,21)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,21)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.sourcePallet = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[2,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n          '])),(_l()(),i1.ɵted((null as any),
          ['\n\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),10,'div',
          [['class','padded-container']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(933888,(null as any),0,i7.ClassDirective,
          [i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n            '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',
          [['class','bg-blue color-white mat-button'],['color','primary'],['md-button',
              '']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.loadItems(_co.sourcePallet)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i7.ClassDirective,[i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵted((null as any),['\n        \n        ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = 'row';
        const currVal_1:any = 'column';
        _ck(_v,1,0,currVal_0,currVal_1);
        const currVal_2:any = '30px';
        const currVal_3:any = '14px';
        _ck(_v,2,0,currVal_2,currVal_3);
        const currVal_4:any = 'padded-container';
        _ck(_v,3,0,currVal_4);
        const currVal_16:any = '47%';
        _ck(_v,13,0,currVal_16);
        const currVal_30:any = _co.sourcePallet;
        _ck(_v,18,0,currVal_30);
        const currVal_31:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,21,0,_ck(_v,22,
            0,i1.ɵnov((<any>_v.parent),0),'load_from_pallet',_co._authService.getLanguage())),
            '');
        _ck(_v,21,0,currVal_31);
        const currVal_32:any = 'padded-container';
        _ck(_v,26,0,currVal_32);
        const currVal_34:any = 'primary';
        _ck(_v,30,0,currVal_34);
        const currVal_35:any = 'bg-blue color-white';
        _ck(_v,32,0,currVal_35);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_5:any = (null as any);
        const currVal_6:any = true;
        const currVal_7:any = i1.ɵnov(_v,6)._isErrorState();
        const currVal_8:any = i1.ɵnov(_v,6)._mdInputChild.focused;
        const currVal_9:any = i1.ɵnov(_v,6)._shouldForward('untouched');
        const currVal_10:any = i1.ɵnov(_v,6)._shouldForward('touched');
        const currVal_11:any = i1.ɵnov(_v,6)._shouldForward('pristine');
        const currVal_12:any = i1.ɵnov(_v,6)._shouldForward('dirty');
        const currVal_13:any = i1.ɵnov(_v,6)._shouldForward('valid');
        const currVal_14:any = i1.ɵnov(_v,6)._shouldForward('invalid');
        const currVal_15:any = i1.ɵnov(_v,6)._shouldForward('pending');
        _ck(_v,5,1,[currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,
            currVal_12,currVal_13,currVal_14,currVal_15]);
        const currVal_17:any = i1.ɵnov(_v,20).ngClassUntouched;
        const currVal_18:any = i1.ɵnov(_v,20).ngClassTouched;
        const currVal_19:any = i1.ɵnov(_v,20).ngClassPristine;
        const currVal_20:any = i1.ɵnov(_v,20).ngClassDirty;
        const currVal_21:any = i1.ɵnov(_v,20).ngClassValid;
        const currVal_22:any = i1.ɵnov(_v,20).ngClassInvalid;
        const currVal_23:any = i1.ɵnov(_v,20).ngClassPending;
        const currVal_24:any = true;
        const currVal_25:any = i1.ɵnov(_v,21).id;
        const currVal_26:any = i1.ɵnov(_v,21).placeholder;
        const currVal_27:any = i1.ɵnov(_v,21).disabled;
        const currVal_28:any = i1.ɵnov(_v,21).required;
        const currVal_29:any = (i1.ɵnov(_v,21).ariaDescribedby || (null as any));
        _ck(_v,15,1,[currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,
            currVal_23,currVal_24,currVal_25,currVal_26,currVal_27,currVal_28,currVal_29]);
        const currVal_33:any = (i1.ɵnov(_v,30).disabled || (null as any));
        _ck(_v,28,0,currVal_33);
        const currVal_36:any = i1.ɵunv(_v,33,0,_ck(_v,34,0,i1.ɵnov((<any>_v.parent),
            0),'load',_co._authService.getLanguage()));
        _ck(_v,33,0,currVal_36);
      });
}
function View_InvChangeLocationComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',
      [['fxFlex','47%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,
          'mat-input-invalid',(null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
      (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,[2,i8.NgForm],
          [2,i8.FormGroupDirective]],(null as any),(null as any)),i1.ɵqud(335544320,
      8,{_mdInputChild:0}),i1.ɵqud(335544320,9,{_placeholderChild:0}),i1.ɵqud(603979776,
      10,{_errorChildren:1}),i1.ɵqud(603979776,11,{_hintChildren:1}),i1.ɵqud(603979776,
      12,{_prefixChildren:1}),i1.ɵqud(603979776,13,{_suffixChildren:1}),i1.ɵdid(737280,
      (null as any),0,i9.FlexDirective,[i5.MediaMonitor,i1.ElementRef,i1.Renderer2,
          [3,i4.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,'flex']},(null as any)),
      (_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,(null as any),1,7,'textarea',
          [['mdInput',''],['rows','10']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[2,'mat-input-element',(null as any)],[8,'id',0],
              [8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,'aria-describedby',
                  0]],[[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend'],
              [(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,11)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,11).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,11)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,11)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,16)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,16)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,16)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.pieceNumbers = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[8,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n          ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_11:any = '47%';
    _ck(_v,8,0,currVal_11);
    const currVal_25:any = _co.pieceNumbers;
    _ck(_v,13,0,currVal_25);
    const currVal_26:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,16,0,_ck(_v,17,0,
        i1.ɵnov((<any>_v.parent),0),'piece_numbers',_co._authService.getLanguage())),
        '');
    _ck(_v,16,0,currVal_26);
  },(_ck,_v) => {
    const currVal_0:any = (null as any);
    const currVal_1:any = true;
    const currVal_2:any = i1.ɵnov(_v,1)._isErrorState();
    const currVal_3:any = i1.ɵnov(_v,1)._mdInputChild.focused;
    const currVal_4:any = i1.ɵnov(_v,1)._shouldForward('untouched');
    const currVal_5:any = i1.ɵnov(_v,1)._shouldForward('touched');
    const currVal_6:any = i1.ɵnov(_v,1)._shouldForward('pristine');
    const currVal_7:any = i1.ɵnov(_v,1)._shouldForward('dirty');
    const currVal_8:any = i1.ɵnov(_v,1)._shouldForward('valid');
    const currVal_9:any = i1.ɵnov(_v,1)._shouldForward('invalid');
    const currVal_10:any = i1.ɵnov(_v,1)._shouldForward('pending');
    _ck(_v,0,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10]);
    const currVal_12:any = i1.ɵnov(_v,15).ngClassUntouched;
    const currVal_13:any = i1.ɵnov(_v,15).ngClassTouched;
    const currVal_14:any = i1.ɵnov(_v,15).ngClassPristine;
    const currVal_15:any = i1.ɵnov(_v,15).ngClassDirty;
    const currVal_16:any = i1.ɵnov(_v,15).ngClassValid;
    const currVal_17:any = i1.ɵnov(_v,15).ngClassInvalid;
    const currVal_18:any = i1.ɵnov(_v,15).ngClassPending;
    const currVal_19:any = true;
    const currVal_20:any = i1.ɵnov(_v,16).id;
    const currVal_21:any = i1.ɵnov(_v,16).placeholder;
    const currVal_22:any = i1.ɵnov(_v,16).disabled;
    const currVal_23:any = i1.ɵnov(_v,16).required;
    const currVal_24:any = (i1.ɵnov(_v,16).ariaDescribedby || (null as any));
    _ck(_v,10,1,[currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17,
        currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24]);
  });
}
function View_InvChangeLocationComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',
      [['fxFlex','47%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,
          'mat-input-invalid',(null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
      (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,[2,i8.NgForm],
          [2,i8.FormGroupDirective]],(null as any),(null as any)),i1.ɵqud(335544320,
      14,{_mdInputChild:0}),i1.ɵqud(335544320,15,{_placeholderChild:0}),i1.ɵqud(603979776,
      16,{_errorChildren:1}),i1.ɵqud(603979776,17,{_hintChildren:1}),i1.ɵqud(603979776,
      18,{_prefixChildren:1}),i1.ɵqud(603979776,19,{_suffixChildren:1}),i1.ɵdid(737280,
      (null as any),0,i9.FlexDirective,[i5.MediaMonitor,i1.ElementRef,i1.Renderer2,
          [3,i4.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,'flex']},(null as any)),
      (_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,(null as any),1,7,'input',
          [['mdInput','']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],
              [2,'mat-input-element',(null as any)],[8,'id',0],[8,'placeholder',0],
              [8,'disabled',0],[8,'required',0],[1,'aria-describedby',0]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend'],[(null as any),
              'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,11)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,11).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,11)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,11)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,16)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,16)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,16)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.pieceNumber = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[14,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n          ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_11:any = '47%';
    _ck(_v,8,0,currVal_11);
    const currVal_25:any = _co.pieceNumber;
    _ck(_v,13,0,currVal_25);
    const currVal_26:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,16,0,_ck(_v,17,0,
        i1.ɵnov((<any>_v.parent),0),'piece_number',_co._authService.getLanguage())),
        '');
    _ck(_v,16,0,currVal_26);
  },(_ck,_v) => {
    const currVal_0:any = (null as any);
    const currVal_1:any = true;
    const currVal_2:any = i1.ɵnov(_v,1)._isErrorState();
    const currVal_3:any = i1.ɵnov(_v,1)._mdInputChild.focused;
    const currVal_4:any = i1.ɵnov(_v,1)._shouldForward('untouched');
    const currVal_5:any = i1.ɵnov(_v,1)._shouldForward('touched');
    const currVal_6:any = i1.ɵnov(_v,1)._shouldForward('pristine');
    const currVal_7:any = i1.ɵnov(_v,1)._shouldForward('dirty');
    const currVal_8:any = i1.ɵnov(_v,1)._shouldForward('valid');
    const currVal_9:any = i1.ɵnov(_v,1)._shouldForward('invalid');
    const currVal_10:any = i1.ɵnov(_v,1)._shouldForward('pending');
    _ck(_v,0,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10]);
    const currVal_12:any = i1.ɵnov(_v,15).ngClassUntouched;
    const currVal_13:any = i1.ɵnov(_v,15).ngClassTouched;
    const currVal_14:any = i1.ɵnov(_v,15).ngClassPristine;
    const currVal_15:any = i1.ɵnov(_v,15).ngClassDirty;
    const currVal_16:any = i1.ɵnov(_v,15).ngClassValid;
    const currVal_17:any = i1.ɵnov(_v,15).ngClassInvalid;
    const currVal_18:any = i1.ɵnov(_v,15).ngClassPending;
    const currVal_19:any = true;
    const currVal_20:any = i1.ɵnov(_v,16).id;
    const currVal_21:any = i1.ɵnov(_v,16).placeholder;
    const currVal_22:any = i1.ɵnov(_v,16).disabled;
    const currVal_23:any = i1.ɵnov(_v,16).required;
    const currVal_24:any = (i1.ɵnov(_v,16).ariaDescribedby || (null as any));
    _ck(_v,10,1,[currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17,
        currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24]);
  });
}
function View_InvChangeLocationComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class',
      'bg-blue color-white mat-button'],['color','primary'],['md-button','']],[[8,
      'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.changePallet()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i3.MdButton,[i1.ElementRef,i1.Renderer2,i3.Platform,
          i3.FocusOriginMonitor],{color:[0,'color']},(null as any)),i1.ɵdid(16384,
          (null as any),0,i3.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(933888,(null as any),0,i7.ClassDirective,[i5.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2)],(_ck,
      _v) => {
    const currVal_1:any = 'primary';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'bg-blue color-white';
    _ck(_v,4,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>_v.parent),0),'change',
        _co._authService.getLanguage()));
    _ck(_v,5,0,currVal_3);
  });
}
function View_InvChangeLocationComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class',
      'bg-blue color-white mat-button'],['color','primary'],['md-button','']],[[8,
      'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.changeAllPallet()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i3.MdButton,[i1.ElementRef,i1.Renderer2,i3.Platform,
          i3.FocusOriginMonitor],{color:[0,'color']},(null as any)),i1.ɵdid(16384,
          (null as any),0,i3.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(933888,(null as any),0,i7.ClassDirective,[i5.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2)],(_ck,
      _v) => {
    const currVal_1:any = 'primary';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'bg-blue color-white';
    _ck(_v,4,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>_v.parent),0),'change_all',
        _co._authService.getLanguage()));
    _ck(_v,5,0,currVal_3);
  });
}
export function View_InvChangeLocationComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵpid(0,i12.TranslatePipe,([] as any[])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),132,'div',[['fxLayout','column']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i4.LayoutDirective,
      [i5.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          128,'div',[['class','boxed-content-wrapper cards-no-gaps']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(933888,
          (null as any),0,i7.ClassDirective,[i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),124,'md-card',([] as any[]),[[2,'mat-card',(null as any)]],
          (null as any),(null as any),i2.View_MdCard_0,i2.RenderType_MdCard)),i1.ɵdid(16384,
          (null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i3.MdCard,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,
          ['\n      '])),(_l()(),i1.ɵeld(0,(null as any),0,28,'md-card-header',[['fxLayout',
          'column']],[[2,'mat-card-header',(null as any)]],(null as any),(null as any),
          i2.View_MdCardHeader_0,i2.RenderType_MdCardHeader)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(49152,(null as any),0,i3.MdCardHeader,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,(null as any),
          0,i4.LayoutDirective,[i5.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,
              'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n        '])),(_l()(),
          i1.ɵeld(0,(null as any),1,15,'md-card-title',([] as any[]),[[2,'mat-card-title',
              (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i3.MdCardTitle,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),10,'span',
          [['class','md-title'],['fxFlex','100']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i9.FlexDirective,
          [i5.MediaMonitor,i1.ElementRef,i1.Renderer2,[3,i4.LayoutDirective],[3,i10.LayoutWrapDirective]],
          {flex:[0,'flex']},(null as any)),i1.ɵdid(933888,(null as any),0,i7.ClassDirective,
          [i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n            PDA /\n            '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),4,'a',([] as any[]),[[1,'target',0],[8,'href',4]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,25).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i13.RouterLinkWithHref,
          [i13.Router,i13.ActivatedRoute,i11.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵpad(1),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),
      (_l()(),i1.ɵted((null as any),[' /\n            ','\n          '])),i1.ɵppd(2),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted(2,['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,5,'md-card-subtitle',[['class','bg-grey color-white text-only']],
          [[2,'mat-card-subtitle',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i3.MdCardSubtitle,([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,
          (null as any),0,i7.ClassDirective,[i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['PDA\n          ',''])),i1.ɵppd(2),
      (_l()(),i1.ɵted(2,['\n      '])),(_l()(),i1.ɵted(0,['\n      '])),(_l()(),i1.ɵeld(0,
          (null as any),0,63,'md-card-content',[['fxLayout','column']],[[2,'mat-card-content',
              (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i3.MdCardContent,([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,
          (null as any),0,i4.LayoutDirective,[i5.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),12,'div',[['class','padded-container'],
          ['fxLayout','row'],['fxLayout.lt-md','column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md',
              '14px']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(737280,(null as any),0,i4.LayoutDirective,[i5.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),
      i1.ɵdid(1720320,(null as any),0,i6.LayoutGapDirective,[i5.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[2,i4.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},
          (null as any)),i1.ɵdid(933888,(null as any),0,i7.ClassDirective,[i5.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'md-slide-toggle',
          ([] as any[]),[[2,'mat-slide-toggle',(null as any)],[2,'mat-checked',(null as any)],
              [2,'mat-disabled',(null as any)],[2,'mat-slide-toggle-label-before',
                  (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',
                  (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)]],[[(null as any),'ngModelChange']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i14.InvChangeLocationComponent = _v.component;
            if (('ngModelChange' === en)) {
              const pd_0:any = ((<any>(_co.multiMode = $event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('ngModelChange' === en)) {
              _co.pieceNumber = '';
              const pd_1:any = ((<any>(_co.pieceNumbers = '')) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i2.View_MdSlideToggle_0,i2.RenderType_MdSlideToggle)),i1.ɵdid(1228800,
          (null as any),0,i3.MdSlideToggle,[i1.ElementRef,i1.Renderer2,i3.FocusOriginMonitor],
          (null as any),(null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i3.MdSlideToggle]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted(0,['Multi-piece mode\n          '])),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n\n\n        \n\n        '])),(_l()(),i1.ɵted((null as any),['\n\n        '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_InvChangeLocationComponent_1)),
      i1.ɵdid(16384,(null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n\n        '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_InvChangeLocationComponent_3)),
      i1.ɵdid(16384,(null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        \n\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),10,'div',[['class','padded-container'],
          ['fxLayout','row'],['fxLayout.lt-md','column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md',
              '14px']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(737280,(null as any),0,i4.LayoutDirective,[i5.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),
      i1.ɵdid(1720320,(null as any),0,i6.LayoutGapDirective,[i5.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[2,i4.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},
          (null as any)),i1.ɵdid(933888,(null as any),0,i7.ClassDirective,[i5.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n\n          '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_InvChangeLocationComponent_4)),i1.ɵdid(16384,(null as any),
          0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n\n          '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_InvChangeLocationComponent_5)),
      i1.ɵdid(16384,(null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n        '])),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),24,'div',[['class','padded-container'],['fxLayout','row'],
              ['fxLayout.lt-md','column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md',
                  '14px']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(737280,(null as any),0,i4.LayoutDirective,[i5.MediaMonitor,
          i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},
          (null as any)),i1.ɵdid(1720320,(null as any),0,i6.LayoutGapDirective,[i5.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[2,i4.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,
          'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),0,i7.ClassDirective,
          [i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',
          [['fxFlex','47%']],[[1,'align',0],[2,'mat-input-container',(null as any)],
              [2,'mat-input-invalid',(null as any)],[2,'mat-focused',(null as any)],
              [2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
                  (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,85)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i8.NgForm],[2,i8.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,20,{_mdInputChild:0}),i1.ɵqud(335544320,21,{_placeholderChild:0}),
      i1.ɵqud(603979776,22,{_errorChildren:1}),i1.ɵqud(603979776,23,{_hintChildren:1}),
      i1.ɵqud(603979776,24,{_prefixChildren:1}),i1.ɵqud(603979776,25,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i5.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i4.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i14.InvChangeLocationComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,95)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,95).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,95)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,95)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,100)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,100)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,100)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.newPallet = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i1.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[20,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i8.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n          '])),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵted(0,
          ['\n\n      '])),(_l()(),i1.ɵeld(0,(null as any),0,24,'md-card-actions',
          ([] as any[]),[[2,'mat-card-actions',(null as any)]],(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i3.MdCardActions,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),19,'div',[['class','table-control-buttons'],['fxFlex',''],
              ['fxFlexAlign','start'],['fxFlexAlign.lt-md','center'],['fxLayoutGap',
                  '12px']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(1720320,(null as any),0,i6.LayoutGapDirective,[i5.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[8,(null as any)]],{gap:[0,'gap']},(null as any)),
      i1.ɵdid(737280,(null as any),0,i9.FlexDirective,[i5.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i4.LayoutDirective],[3,i10.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),i1.ɵdid(737280,(null as any),0,i15.FlexAlignDirective,
          [i5.MediaMonitor,i1.ElementRef,i1.Renderer2],{align:[0,'align'],alignLtMd:[1,
              'alignLtMd']},(null as any)),i1.ɵdid(933888,(null as any),0,i7.ClassDirective,
          [i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_InvChangeLocationComponent_6)),i1.ɵdid(16384,(null as any),
          0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_InvChangeLocationComponent_7)),i1.ɵdid(16384,
          (null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),6,'button',[['class','bg-red color-white mat-button'],
              ['color','warn'],['md-button','']],[[8,'disabled',0]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i14.InvChangeLocationComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.goBack()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i7.ClassDirective,[i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵted(0,
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n'])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i14.InvChangeLocationComponent = _v.component;
    const currVal_0:any = 'column';
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = 'boxed-content-wrapper cards-no-gaps';
    _ck(_v,5,0,currVal_1);
    const currVal_4:any = 'column';
    _ck(_v,14,0,currVal_4);
    const currVal_6:any = '100';
    _ck(_v,21,0,currVal_6);
    const currVal_7:any = 'md-title';
    _ck(_v,22,0,currVal_7);
    const currVal_10:any = _ck(_v,26,0,'/pda/inventory');
    _ck(_v,25,0,currVal_10);
    const currVal_14:any = 'bg-grey color-white text-only';
    _ck(_v,36,0,currVal_14);
    const currVal_17:any = 'column';
    _ck(_v,44,0,currVal_17);
    const currVal_18:any = 'row';
    const currVal_19:any = 'column';
    _ck(_v,47,0,currVal_18,currVal_19);
    const currVal_20:any = '30px';
    const currVal_21:any = '14px';
    _ck(_v,48,0,currVal_20,currVal_21);
    const currVal_22:any = 'padded-container';
    _ck(_v,49,0,currVal_22);
    const currVal_34:any = _co.multiMode;
    _ck(_v,54,0,currVal_34);
    const currVal_35:any = _co.multiMode;
    _ck(_v,62,0,currVal_35);
    const currVal_36:any = _co.multiMode;
    _ck(_v,65,0,currVal_36);
    const currVal_37:any = 'row';
    const currVal_38:any = 'column';
    _ck(_v,68,0,currVal_37,currVal_38);
    const currVal_39:any = '30px';
    const currVal_40:any = '14px';
    _ck(_v,69,0,currVal_39,currVal_40);
    const currVal_41:any = 'padded-container';
    _ck(_v,70,0,currVal_41);
    const currVal_42:any = _co.multiMode;
    _ck(_v,73,0,currVal_42);
    const currVal_43:boolean = !_co.multiMode;
    _ck(_v,76,0,currVal_43);
    const currVal_44:any = 'row';
    const currVal_45:any = 'column';
    _ck(_v,80,0,currVal_44,currVal_45);
    const currVal_46:any = '30px';
    const currVal_47:any = '14px';
    _ck(_v,81,0,currVal_46,currVal_47);
    const currVal_48:any = 'padded-container';
    _ck(_v,82,0,currVal_48);
    const currVal_60:any = '47%';
    _ck(_v,92,0,currVal_60);
    const currVal_74:any = _co.newPallet;
    _ck(_v,97,0,currVal_74);
    const currVal_75:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,100,0,_ck(_v,101,
        0,i1.ɵnov(_v,0),'new_pallet',_co._authService.getLanguage())),'');
    _ck(_v,100,0,currVal_75);
    const currVal_77:any = '12px';
    _ck(_v,111,0,currVal_77);
    const currVal_78:any = '';
    _ck(_v,112,0,currVal_78);
    const currVal_79:any = 'start';
    const currVal_80:any = 'center';
    _ck(_v,113,0,currVal_79,currVal_80);
    const currVal_81:any = 'table-control-buttons';
    _ck(_v,114,0,currVal_81);
    const currVal_82:boolean = !_co.multiMode;
    _ck(_v,117,0,currVal_82);
    const currVal_83:any = _co.multiMode;
    _ck(_v,120,0,currVal_83);
    const currVal_85:any = 'warn';
    _ck(_v,124,0,currVal_85);
    const currVal_86:any = 'bg-red color-white';
    _ck(_v,126,0,currVal_86);
  },(_ck,_v) => {
    var _co:i14.InvChangeLocationComponent = _v.component;
    const currVal_2:any = true;
    _ck(_v,7,0,currVal_2);
    const currVal_3:any = true;
    _ck(_v,11,0,currVal_3);
    const currVal_5:any = true;
    _ck(_v,16,0,currVal_5);
    const currVal_8:any = i1.ɵnov(_v,25).target;
    const currVal_9:any = i1.ɵnov(_v,25).href;
    _ck(_v,24,0,currVal_8,currVal_9);
    const currVal_11:any = i1.ɵunv(_v,27,0,_ck(_v,28,0,i1.ɵnov(_v,0),'inventory',_co._authService.getLanguage()));
    _ck(_v,27,0,currVal_11);
    const currVal_12:any = i1.ɵunv(_v,29,0,_ck(_v,30,0,i1.ɵnov(_v,0),'move_item',_co._authService.getLanguage()));
    _ck(_v,29,0,currVal_12);
    const currVal_13:any = true;
    _ck(_v,33,0,currVal_13);
    const currVal_15:any = i1.ɵunv(_v,37,0,_ck(_v,38,0,i1.ɵnov(_v,0),'move_item',_co._authService.getLanguage()));
    _ck(_v,37,0,currVal_15);
    const currVal_16:any = true;
    _ck(_v,41,0,currVal_16);
    const currVal_23:any = true;
    const currVal_24:any = i1.ɵnov(_v,52).checked;
    const currVal_25:any = i1.ɵnov(_v,52).disabled;
    const currVal_26:any = (i1.ɵnov(_v,52).labelPosition == 'before');
    const currVal_27:any = i1.ɵnov(_v,56).ngClassUntouched;
    const currVal_28:any = i1.ɵnov(_v,56).ngClassTouched;
    const currVal_29:any = i1.ɵnov(_v,56).ngClassPristine;
    const currVal_30:any = i1.ɵnov(_v,56).ngClassDirty;
    const currVal_31:any = i1.ɵnov(_v,56).ngClassValid;
    const currVal_32:any = i1.ɵnov(_v,56).ngClassInvalid;
    const currVal_33:any = i1.ɵnov(_v,56).ngClassPending;
    _ck(_v,51,1,[currVal_23,currVal_24,currVal_25,currVal_26,currVal_27,currVal_28,
        currVal_29,currVal_30,currVal_31,currVal_32,currVal_33]);
    const currVal_49:any = (null as any);
    const currVal_50:any = true;
    const currVal_51:any = i1.ɵnov(_v,85)._isErrorState();
    const currVal_52:any = i1.ɵnov(_v,85)._mdInputChild.focused;
    const currVal_53:any = i1.ɵnov(_v,85)._shouldForward('untouched');
    const currVal_54:any = i1.ɵnov(_v,85)._shouldForward('touched');
    const currVal_55:any = i1.ɵnov(_v,85)._shouldForward('pristine');
    const currVal_56:any = i1.ɵnov(_v,85)._shouldForward('dirty');
    const currVal_57:any = i1.ɵnov(_v,85)._shouldForward('valid');
    const currVal_58:any = i1.ɵnov(_v,85)._shouldForward('invalid');
    const currVal_59:any = i1.ɵnov(_v,85)._shouldForward('pending');
    _ck(_v,84,1,[currVal_49,currVal_50,currVal_51,currVal_52,currVal_53,currVal_54,
        currVal_55,currVal_56,currVal_57,currVal_58,currVal_59]);
    const currVal_61:any = i1.ɵnov(_v,99).ngClassUntouched;
    const currVal_62:any = i1.ɵnov(_v,99).ngClassTouched;
    const currVal_63:any = i1.ɵnov(_v,99).ngClassPristine;
    const currVal_64:any = i1.ɵnov(_v,99).ngClassDirty;
    const currVal_65:any = i1.ɵnov(_v,99).ngClassValid;
    const currVal_66:any = i1.ɵnov(_v,99).ngClassInvalid;
    const currVal_67:any = i1.ɵnov(_v,99).ngClassPending;
    const currVal_68:any = true;
    const currVal_69:any = i1.ɵnov(_v,100).id;
    const currVal_70:any = i1.ɵnov(_v,100).placeholder;
    const currVal_71:any = i1.ɵnov(_v,100).disabled;
    const currVal_72:any = i1.ɵnov(_v,100).required;
    const currVal_73:any = (i1.ɵnov(_v,100).ariaDescribedby || (null as any));
    _ck(_v,94,1,[currVal_61,currVal_62,currVal_63,currVal_64,currVal_65,currVal_66,
        currVal_67,currVal_68,currVal_69,currVal_70,currVal_71,currVal_72,currVal_73]);
    const currVal_76:any = true;
    _ck(_v,106,0,currVal_76);
    const currVal_84:any = (i1.ɵnov(_v,124).disabled || (null as any));
    _ck(_v,122,0,currVal_84);
    const currVal_87:any = i1.ɵunv(_v,127,0,_ck(_v,128,0,i1.ɵnov(_v,0),'back',_co._authService.getLanguage()));
    _ck(_v,127,0,currVal_87);
  });
}
export function View_InvChangeLocationComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'app-inv-change-pallet',
      ([] as any[]),(null as any),(null as any),(null as any),View_InvChangeLocationComponent_0,
      RenderType_InvChangeLocationComponent)),i1.ɵprd(512,(null as any),i16.PalletService,
      i16.PalletService,[i17.Http,i18.Configuration,i19.AuthenticationService]),i1.ɵdid(114688,
      (null as any),0,i14.InvChangeLocationComponent,[i20.TdDialogService,i3.MdSnackBar,
          i19.AuthenticationService,i21.InventoryService,i16.PalletService,i11.Location],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const InvChangeLocationComponentNgFactory:i1.ComponentFactory<i14.InvChangeLocationComponent> = i1.ɵccf('app-inv-change-pallet',
    i14.InvChangeLocationComponent,View_InvChangeLocationComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/pda/inventory/change-pallet/change-pallet.component.ngfactory.ts